// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__MQzSp","ranges":"BmiRanges_ranges__19-8L"};